import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { heroImage, included, price } from '../data/copy';
import { launchPrice, totalValue, valueStack } from '../data/valueStack';
const assurances = ['Secure payment', 'Instant download', '7-day money back guarantee'];
export function OfferSection() {
  return <section id="offer" className="defer-paint w-full scroll-mt-16 bg-navy-deep py-11 sm:py-16" aria-labelledby="offer-heading" data-id="element-105" data-mp="idrl5hvbccvp">
      <div className="mx-auto max-w-5xl px-6" data-id="element-106" data-mp="mdif1ug4z94g">
        <CountdownTimer data-id="element-107" data-mp="rdwq7ld1az6p" />

        <div className="mx-auto mt-9 max-w-2xl text-center" data-id="element-108" data-mp="rdmyntcccjyw">
          <p className="eyebrow text-lime" data-id="element-109" data-mp="rc3l4ai2kn0t">💰 The value stack</p>
          <h2 id="offer-heading" className="mt-4 font-display text-[1.9rem] font-extrabold leading-[1.1] text-shell sm:text-4xl" data-id="element-110" data-mp="wchh2u6ec6ih">
            $308 of coaching system. $27 today.
          </h2>
        </div>

        <div className="mt-7 grid gap-8 rounded-4xl bg-shell p-6 shadow-lift sm:p-9 lg:grid-cols-[0.95fr_1.05fr] lg:gap-10" data-id="element-111" data-mp="2y4mgeqq86638">
          <div className="flex flex-col" data-id="element-112" data-mp="12pd0v7e66i19">
            <div className="rounded-3xl bg-sand p-5 sm:p-7" data-id="element-113" data-mp="xvqvm0ac5gfh">
              <img src={heroImage} alt="Everything included: six volumes, seven strategic bonuses and printable coaching resources." className="mx-auto w-full max-w-sm" width={1240} height={1240} sizes="384px" loading="lazy" decoding="async" data-id="element-114" data-mp="sxp20lfa9ypr" />
            </div>

            <dl className="mt-6 rounded-3xl border border-line bg-ivory px-6 py-6" data-id="element-115" data-mp="1llunxbi2ptr6">
              {valueStack.map(line => <div key={line.label} className="flex items-baseline justify-between gap-4 border-b border-line py-2.5 font-sans text-[0.88rem] text-ink/85 first:pt-0" data-id="element-116" data-mp="1go2si7i7zpi8">
                  <dt data-id="element-117" data-mp="17ljx28grkf60">{line.label}</dt>
                  <dd className="font-display font-bold text-stone line-through" data-id="element-118" data-mp="17opmxpx7vl2s">
                    {line.value}
                  </dd>
                </div>)}
              <div className="flex items-baseline justify-between gap-4 pt-3 font-sans text-[0.88rem] font-semibold text-ink" data-id="element-119" data-mp="3sbstu274apcq">
                <dt data-id="element-120" data-mp="3tusnyevgpjrk">Total real-world value</dt>
                <dd className="font-display text-lg font-extrabold text-stone line-through" data-id="element-121" data-mp="2o82rbs3962g">
                  {totalValue}
                </dd>
              </div>
            </dl>

            <div className="mt-4 rounded-3xl border border-lime-ink/30 bg-lime-soft px-6 py-7 text-center" data-id="element-122" data-mp="3ouwkqhul9wd2">
              <p className="eyebrow text-lime-ink" data-id="element-123" data-mp="3b3rsw1xgq8da">Launch price today</p>
              <p className="mt-2 flex items-start justify-center gap-1 font-display text-[3.5rem] font-extrabold leading-none text-ink" data-id="element-124" data-mp="3b1otiraf72vw">
                <span className="mt-2.5 text-2xl" data-id="element-125" data-mp="3163m2dml1aer">$</span>
                {launchPrice.replace('$', '')}
              </p>
              <p className="mt-2 font-sans text-xs uppercase tracking-[0.16em] text-stone" data-id="element-126" data-mp="3656sa1eatmob">
                One payment · adjusts to your local currency
              </p>
            </div>

            <CtaButton size="large" className="mt-5 w-full" data-id="element-127" data-mp="2x2p43hf32jyo">
              Get instant access — {price}
            </CtaButton>

            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-128" data-mp="2di749367m6zx">
              {assurances.map(item => <li key={item} className="flex items-center gap-1.5 font-sans text-[11px] text-stone" data-id="element-129" data-mp="28l6vullw0s5n">
                  <CheckIcon className="h-3.5 w-3.5 text-lime-ink" strokeWidth={2.6} aria-hidden="true" data-id="element-130" data-mp="2mgaf95jkjldh" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div data-id="element-131" data-mp="2weq4f2z1ckkc">
            <p className="eyebrow text-navy" data-id="element-132" data-mp="2weggrm1gqpht">Everything included</p>
            <ul className="mt-6 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-133" data-mp="2rh6olymovzqa">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 font-sans text-[0.88rem] leading-relaxed text-ink/85" data-id="element-134" data-mp="3662ym18b3mtj">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-lime-ink" strokeWidth={2.6} aria-hidden="true" data-id="element-135" data-mp="319m6kvxzkob6" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-8 rounded-3xl bg-sand px-6 py-7" data-id="element-136" data-mp="3aa0xcatpyvm2">
              <h3 className="font-display text-lg font-bold leading-snug text-ink sm:text-xl" data-id="element-137" data-mp="18hz31snpkyvs">
                Think about what one hour of your planning time is worth.
              </h3>
              <p className="mt-4 font-sans text-sm leading-relaxed text-stone" data-id="element-138" data-mp="1i8bodn3ckw2z">
                One hour this Sunday. Another next Sunday. Another the week
                after. The value of the Vault isn’t the number of PDFs inside —
                it’s the planning you never have to start from zero again.
              </p>
              <p className="mt-4 font-sans text-sm leading-relaxed text-ink" data-id="element-139" data-mp="uk27mzkzqyip">
                And every clinic you teach from it, the system pays you back
                again.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}